import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { UIFormItem, UIInput } from '@gohighlevel/ghl-ui';
export default /*#__PURE__*/ _defineComponent({
    __name: 'FormInputItem',
    props: {
        modelValue: {},
        itemLabel: {},
        itemPlaceholder: {},
        itemId: {}
    },
    emits: ["update:modelValue"],
    setup(__props, { emit: __emit }) {
        const emit = __emit;
        const onInput = (val) => {
            emit('update:modelValue', val);
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(_unref(UIFormItem), {
                label: _ctx.itemLabel,
                path: _ctx.itemId
            }, {
                default: _withCtx(() => [
                    _createVNode(_unref(UIInput), {
                        value: _ctx.modelValue,
                        onInput: onInput,
                        placeholder: _ctx.itemPlaceholder,
                        id: _ctx.itemId
                    }, null, 8, ["value", "placeholder", "id"])
                ]),
                _: 1
            }, 8, ["label", "path"]));
        };
    }
});
